export default "__VITE_ASSET__CFEATLD3__"